<template>
  <div dir="rtl">
    <header class="hidden lg:flex fixed top-0 w-full z-50 bg-[#0f1417]/80 backdrop-blur-md">
      <nav class="max-w-7xl mx-auto px-8 py-3 flex items-center justify-center">
        <div class="flex gap-1">
          <router-link
            to="/user"
            class="relative inline-flex items-center px-4 py-2 rounded-xl text-sm transition group"
            :class="isActive('/user') ? 'text-[#b9f1cf] bg-[#1e2623] ring-1 ring-[#334D44]/60' : 'text-white/80 hover:text-white hover:bg-[#141a1e] ring-1 ring-transparent hover:ring-[#334D44]/40'">
            <span>خانه</span>
            <span
              class="absolute -bottom-1 left-1/2 h-0.5 w-10 -translate-x-1/2 bg-[#b9f1cf] scale-x-0 group-hover:scale-x-100 transition"
              v-if="isActive('/user')"></span>
          </router-link>

          <router-link
            to="/user/price"
            class="relative inline-flex items-center px-4 py-2 rounded-xl text-sm transition group"
            :class="isActive('/user/price') ? 'text-[#b9f1cf] bg-[#1e2623] ring-1 ring-[#334D44]/60' : 'text-white/80 hover:text-white hover:bg-[#141a1e] ring-1 ring-transparent hover:ring-[#334D44]/40'">
           <span>تابلو قیمت</span>
            <span class="absolute -bottom-1 left-1/2 h-0.5 w-10 -translate-x-1/2 bg-[#b9f1cf] scale-x-0 group-hover:scale-x-100 transition"
                  v-if="isActive('/user/price')"></span>
          </router-link>
        

          <router-link
            to="/user/history"
            class="relative inline-flex items-center px-4 py-2 rounded-xl text-sm transition group"
            :class="isActive('/user/history') ? 'text-[#b9f1cf] bg-[#1e2623] ring-1 ring-[#334D44]/60' : 'text-white/80 hover:text-white hover:bg-[#141a1e] ring-1 ring-transparent hover:ring-[#334D44]/40'">
            <span>تاریخچه</span>
            <span class="absolute -bottom-1 left-1/2 h-0.5 w-10 -translate-x-1/2 bg-[#b9f1cf] scale-x-0 group-hover:scale-x-100 transition"
                  v-if="isActive('/user/history')"></span>
          </router-link>

         

          <router-link
            to="/user/wallet"
            class="relative inline-flex items-center px-4 py-2 rounded-xl text-sm transition group"
            :class="isActive('/user/wallet') ? 'text-[#b9f1cf] bg-[#1e2623] ring-1 ring-[#334D44]/60' : 'text-white/80 hover:text-white hover:bg-[#141a1e] ring-1 ring-transparent hover:ring-[#334D44]/40'">
            <span>کیف پول</span>
            <span class="absolute -bottom-1 left-1/2 h-0.5 w-10 -translate-x-1/2 bg-[#b9f1cf] scale-x-0 group-hover:scale-x-100 transition"
                  v-if="isActive('/user/wallet')"></span>
          </router-link>

          <router-link
            to="/user/profile"
            class="relative inline-flex items-center px-4 py-2 rounded-xl text-sm transition group"
            :class="isActive('/user/profile') ? 'text-[#b9f1cf] bg-[#1e2623] ring-1 ring-[#334D44]/60' : 'text-white/80 hover:text-white hover:bg-[#141a1e] ring-1 ring-transparent hover:ring-[#334D44]/40'">
            <span>پروفایل</span>
            <span class="absolute -bottom-1 left-1/2 h-0.5 w-10 -translate-x-1/2 bg-[#b9f1cf] scale-x-0 group-hover:scale-x-100 transition"
                  v-if="isActive('/user/profile')"></span>
          </router-link>
        </div>
      </nav>
    </header>

    <footer class="lg:hidden fixed bottom-0 left-0 w-full z-50 bg-[#0f1417]/90 backdrop-blur-md ring-1 ring-[#334D44]/60">
      <nav class="max-w-7xl mx-auto px-4 pt-2 pb-3 grid grid-cols-5 gap-1">
        <router-link
          to="/user"
          class="flex flex-col items-center gap-1 rounded-xl py-2"
          :class="isActive('/user') ? 'text-[#b9f1cf] bg-[#141a1e] ring-1 ring-[#334D44]/60' : 'text-white/70'">
          <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955a1.125 1.125 0 0 1 1.591 0L21.75 12M4.5 9.75V21h15V9.75"/>
          </svg>
          <span class="text-[11px]">خانه</span>
        </router-link>

        <router-link
          to="/user/history"
          class="flex flex-col items-center gap-1 rounded-xl py-2"
          :class="isActive('/user/history') ? 'text-[#b9f1cf] bg-[#141a1e] ring-1 ring-[#334D44]/60' : 'text-white/70'">
          <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <span class="text-[11px]">تاریخچه</span>
        </router-link>

        <router-link
          to="/user/price"
          class="flex flex-col items-center gap-1 rounded-xl py-2"
          :class="isActive('/user/price') ? 'text-[#b9f1cf] bg-[#141a1e] ring-1 ring-[#334D44]/60' : 'text-white/70'">
          <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 12h7l2-3 4 6 2-3h3"/>
          </svg>
          <span class="text-[11px]">تابلو قیمت </span>
        </router-link>

        <router-link
          to="/user/wallet"
          class="flex flex-col items-center gap-1 rounded-xl py-2"
          :class="isActive('/user/wallet') ? 'text-[#b9f1cf] bg-[#141a1e] ring-1 ring-[#334D44]/60' : 'text-white/70'">
          <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 7h18v10H3zM16 12h4"/>
          </svg>
          <span class="text-[11px]">کیف پول</span>
        </router-link>

        <router-link
          to="/user/profile"
          class="flex flex-col items-center gap-1 rounded-xl py-2"
          :class="isActive('/user/profile') ? 'text-[#b9f1cf] bg-[#141a1e] ring-1 ring-[#334D44]/60' : 'text-white/70'">
          <svg viewBox="0 0 24 24" class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 14a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm7 7a7 7 0 0 0-14 0"/>
          </svg>
          <span class="text-[11px]">پروفایل</span>
        </router-link>
      </nav>
    </footer>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const route = useRoute()
const isActive = (path) => computed(() => route.path.startsWith(path)).value
</script>

<style scoped>
</style>
